import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import { getTypeColor } from "../../../shared-functions/notification";
import { ApplyStyle as _s } from "../../../utils/ApplyStyle";
import { useSelector } from "react-redux";

import CancelIcon from '@mui/icons-material/Cancel';
import clsx from "clsx";
import { Theme247 } from "../../../styles/Theme247";
import { NotificationType, getNotificationTooltipAndColor } from "../../../types";
import { truncateWithEllipses } from '../../../utils/helpers';

const NotificationCardItem = (props) => {
  /*
  * States, Constants
  */
  const i18n = useSelector((state) => state.i18n);
  const cardStyle = generateCardStyle(props.type);

  function generateCardStyle(typecode) {
    if (typecode !== null) {
      let text = NotificationType(Number(typecode));

      return { status: getTypeColor(typecode, 'card').class, text: text };
    } else {
      return { status: getTypeColor(undefined, 'card'), text: 'Undefined card typecode.' };
    }
  }

  /*
  * Styles
  */

  const handleClick = (type) => {
    //stroung cross
    if (type == 12) {
      if (props.storungCross) {
        props.StorungCrossClick(false)
      }
      else {
        props.StorungCrossClick(true)
      }
    }
    else if (type == 1) {
      //auff cross
      if (props.auffCross) {
        props.AuffCrossClick(false)
      }
      else {
        props.AuffCrossClick(true)
      }
    }

    else if (type == 2) {
      //notiz cross
      if (props.notizCross) {
        props.NotizCrossClick(false)
      }
      else {
        props.NotizCrossClick(true)
      }
    }

    else if(type==6){
      //wartungen cross
    if (props.wartungenCross) {
      props.WartungenCrossClick(false)
    }
    else {
      props.WartungenCrossClick(true)
    }
    }

    
  }



  return (
    <Card raised={true} elevation={Theme247.elevationLow} className={clsx('cardItem', _s(Theme247.itemcard.wrapper))} onClick={()=>handleClick(props.type)}>
      <CardActionArea className={_s(Theme247.itemcard.actionAreaWrapper)}>
        <div style={{borderTop:`6px solid ${props.bgColor}`}} className={clsx(_s(Theme247.itemcard.cardInner), _s(Theme247.itemcard.status[cardStyle.status]))}>
          <div className={_s(Theme247.itemcard.cardTextContainer)} >
            <div className={_s(Theme247.itemcard.header)}>
              <div  className={_s(Theme247.itemcard.title)} title={NotificationType(Number(props.type))}>
              <div className="flexDiv" >
                <div className="font_bold">{ props.type === 12 ? (props.storungCount > 1 ? i18n.notificationtype_malfunction : i18n.disturbed) : truncateWithEllipses(NotificationType(Number(props.type),props.storungCount || props.AuffCounter || props.WartungenCounter),20) } {(props.type == 12 ? props.storungCount : props.type == 1 ? props.AuffCounter : props.type == 2 ? props.NotizCounter : props.WartungenCounter)}</div>
                <div style={{ borderRadius: 25,height:20,display:props.StorungUnReadCounter==0||props.AuffUnReadCounter==0||props.NotizUnReadCounter==0||props.WartungenUnReadCounter == 0?"none":"flex",background: props.type === 12 ? getNotificationTooltipAndColor(0)?.color : getNotificationTooltipAndColor(props.type)?.color, padding: "2px 6px 2px 6px",fontSize:12,color:"#ffffff",alignItems:"center", justifyContent:"center", fontWeight:"bold" }}>
                  {(props.type == 12 ? props.StorungUnReadCounter : props.type == 7 ? props.AuffUnReadCounter : props.type == 2 ? props.NotizUnReadCounter : props.WartungenUnReadCounter)} {i18n.new_badge}
                </div>
                <CancelIcon style={{ display: ((props.storungCross||props.auffCross||props.notizCross||props.wartungenCross) ? 'block' : 'none') }} />
                </div>
               </div>
            </div>
          </div>
        </div>
      </CardActionArea>
    </Card>
  );
};

NotificationCardItem.defaultProps = {
  showNotificationDetails: true,
  showEquipment: false,
};


//export default connect(({ i18n, data }) => ({ i18n, data }), {})(NotificationCardItem);
export default NotificationCardItem;
